// extracted by mini-css-extract-plugin
module.exports = {"w3lf4x5":"w3lf4x5"};